import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { formatCurrency, formatNumber } from './numberFormatHandler';
import { Currency } from '@/constants/enums/currency.enum';

interface AmountInputProps extends Omit<TextFieldProps, 'onChange' | 'value'> {
  value: number;
  onChange: (value: number) => void;
  name: string;
  error?: boolean;
  helperText?: React.ReactNode;
}

const AmountInput: React.FC<AmountInputProps> = ({
  value,
  onChange,
  name,
  ...props
}) => {
  // Display value (formatted)
  const [displayValue, setDisplayValue] = React.useState<string>('');

  // Update display value when actual value changes
  React.useEffect(() => {
    setDisplayValue(formatNumber(value));
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Remove any non-numeric characters except decimal point
    const rawValue = e.target.value.replace(/[^0-9.]/g, '');
    
    // Update display value for the input
    setDisplayValue(formatNumber(Number(rawValue)));
    
    // Pass the raw number value to parent
    if (!isNaN(Number(rawValue))) {
      onChange(Number(rawValue));
    }
  };

  const handleBlur = () => {
    // Ensure display value is properly formatted on blur
    setDisplayValue(formatNumber(value));
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    // Optional: Move cursor to end of input on focus
    const target = e.target;
    target.setSelectionRange(target.value.length, target.value.length);
  };

  return (
    <TextField
      {...props}
      fullWidth
      name={name}
      variant="outlined"
      placeholder="Enter Amount"
      className="tw-w-full tw-h-11 tw-px-3 tw-border tw-border-[#D5D7DA] tw-rounded-md tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500"
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      InputProps={{
        // startAdornment: formatCurrency(0, Currency.ZAR).replace(/[0-9.,]/g, ''),
      }}
    />
  );
};

export default AmountInput;
